var map = {
	"./ar/button.js": "3e41",
	"./ar/components.js": "b443",
	"./ar/fields.js": "aee1",
	"./ar/forms.js": "5aad",
	"./ar/message.js": "9518",
	"./en/button.js": "5aed",
	"./en/components.js": "5e98",
	"./en/fields.js": "b7b7",
	"./en/forms.js": "f690",
	"./en/message.js": "2798",
	"./fa/button.js": "95bc",
	"./fa/components.js": "9412",
	"./fa/fields.js": "95ec",
	"./fa/forms.js": "c5ed",
	"./fa/message.js": "5085"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1e4";